import office from 'assets/images/vb/office.jpg';
import officeThumb from 'assets/images/vb/thumb_office.jpg';
import beach from 'assets/images/vb/beach.jpg';
import beachThumb from 'assets/images/vb/thumb_beach.jpg';
import bookshelf from 'assets/images/vb/bookshelf.jpg';
import bookshelfThumb from 'assets/images/vb/thumb_bookshelf.jpg';
import fireworks from 'assets/images/vb/fireworks.jpg';
import fireworksThumb from 'assets/images/vb/thumb_fireworks.jpg';
import forest from 'assets/images/vb/forest.jpg';
import forestThumb from 'assets/images/vb/thumb_forest.jpg';
import mountain from 'assets/images/vb/mountain.jpg';
import mountainThumb from 'assets/images/vb/thumb_mountain.jpg';
import office2 from 'assets/images/vb/office2.jpg';
import office2Thumb from 'assets/images/vb/thumb_office2.jpg';
import savana from 'assets/images/vb/savana.jpg';
import savanaThumb from 'assets/images/vb/thumb_savana.jpg';
import vbg1 from 'assets/images/vb/v_bg01.jpg';
import vbg2 from 'assets/images/vb/v_bg02.jpg';
import vbg3 from 'assets/images/vb/v_bg03.jpg';
import vbg4 from 'assets/images/vb/v_bg04.jpg';
import { VirtualBackgroundItem } from 'features/virtual-backgrounds/types';
import { canExposeInternals } from 'utils/development';

const blurBackgrounds: VirtualBackgroundItem[] = [
  {
    id: 'balanced-blur',
    type: 'blur',
    value: '0.4',
    label: 'Light Blur',
  },
  {
    id: 'strong-blur',
    type: 'blur',
    value: '0.8',
    label: 'Strong Blur',
  },
];

const imageBackgrounds: VirtualBackgroundItem[] = [
  {
    id: 'office',
    type: 'image',
    value: office,
    thumbnail: officeThumb,
    label: 'Office',
  },
  {
    id: 'office2',
    type: 'image',
    value: office2,
    thumbnail: office2Thumb,
    label: 'Office 2',
  },
  {
    id: 'beach',
    type: 'image',
    value: beach,
    thumbnail: beachThumb,
    label: 'Palm beach',
  },
  {
    id: 'fireworks',
    type: 'image',
    value: fireworks,
    thumbnail: fireworksThumb,
    label: 'Fireworks',
  },
  {
    id: 'bookshelf',
    type: 'image',
    value: bookshelf,
    thumbnail: bookshelfThumb,
    label: 'Bookshelf',
  },
  {
    id: 'forest',
    type: 'image',
    value: forest,
    thumbnail: forestThumb,
    label: 'Forest',
  },
  {
    id: 'mountain',
    type: 'image',
    value: mountain,
    thumbnail: mountainThumb,
    label: 'Mountain',
  },
  {
    id: 'savannah',
    type: 'image',
    value: savana,
    thumbnail: savanaThumb,
    label: 'Savana',
  },
];

const videoBackgrounds: VirtualBackgroundItem[] = [
  {
    id: 'vbg1',
    type: 'video',
    value: 'https://demos.digitalsamba.com/video/vb/Motion_Graphic_1920x1080.mp4',
    thumbnail: vbg1,
    label: 'Motion Graphic',
  },
  {
    id: 'vbg2',
    type: 'video',
    value: 'https://demos.digitalsamba.com/video/vb/Motion_Graphic_tech_1280x720.mp4',
    thumbnail: vbg2,
    label: 'Tech Motion',
  },
  {
    id: 'vbg3',
    type: 'video',
    value: 'https://demos.digitalsamba.com/video/vb/Motion_Graphic1_1280x720.mp4',
    thumbnail: vbg3,
    label: 'Abstract Motion',
  },
  {
    id: 'vbg4',
    type: 'video',
    value: 'https://demos.digitalsamba.com/video/vb/video_bg_autumn.mp4',
    thumbnail: vbg4,
    label: 'Autumn',
  },
];

export const defaultVirtualBackgrounds: VirtualBackgroundItem[] = [
  ...blurBackgrounds,
  ...imageBackgrounds,
  ...(canExposeInternals() ? videoBackgrounds : []),
];
